module.exports = __webpack_public_path__ + "static/media/gallery12.1e450b78.jpeg";